import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw24px =
  'M22.34,4.37a.74.74,0,0,0-.77,0l-8.82,6.13V5a.75.75,0,0,0-1.18-.61l-10,7a.76.76,0,0,0-.33.61.74.74,0,0,0,.33.62l10,7a.76.76,0,0,0,.43.14.73.73,0,0,0,.35-.09.75.75,0,0,0,.4-.66V13.42l8.81,6.16a.76.76,0,0,0,.43.14.76.76,0,0,0,.75-.75V5A.74.74,0,0,0,22.34,4.37ZM11.25,17.53,3.32,12l7.93-5.52Zm10,0L13.31,12l7.93-5.52Z';

const icons: IconVariations = {
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ArrowBackwardIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'arrowBackward')) as IconWithRender;

ArrowBackwardIcon.displayName = 'ArrowBackwardIcon';
ArrowBackwardIcon.propTypes = Icon.propTypes;
ArrowBackwardIcon.renderIcon = (props) => <ArrowBackwardIcon {...props} />;
export default ArrowBackwardIcon;
